import { MapUsers, User } from './types';

export function getMapUsers(users: User[]): MapUsers[] {
  return users.map((user: User) => ({
    ...user,
    name: `${user.firstName} ${user.lastName}`,
    pharmacistPin: user.pharmacistPin || '',
    pharmacyId: user.pharmacyId || '',
    webToolAccess: user.webToolAccess || false,
    boxAccess: user.boxAccess || false
  }));
}
